import React from "react";
import { useSelector } from "react-redux";
import { Line as RechartsLine } from "recharts";

import {
  curveInfo,
  getLegendInfo,
  sortRule,
  sortType,
} from "../../../model/Common";
import { chartSetting } from "../../../model/DataGraph";
import { selector as referenceLineStoreSelector } from "../../../store/ReferenceLineStore";

/* ライン描画 */
const Line = (key) => {
  // Store情報
  const {
    // グラフ線図情報(DB取得)
    referenceLines,
  } = useSelector(referenceLineStoreSelector);

  // グラフ線図データ群から線種が一致するデータを取得
  let line = referenceLines.find((item) => item.type === key);
  if (!line) return null;

  // グラフ線図データからY軸の絶対上下限値を超過するデータを排除
  const filterLineValue = line.value.filter(
    (point) => point[1] <= chartSetting.y.max && point[1] >= chartSetting.y.min
  );

  if (filterLineValue.length > 0) {
    line = { ...line, value: filterLineValue };
  } else {
    return null;
  }

  // グラフ描画に使用できる形式へ整形(Object変換)
  const value = line.value.map((point) => ({
    eccentricity: point[0],
    totalLoad: point[1],
  }));

  // X軸(偏心量)でソート
  const data = value.sort((a, b) => {
    if (a.eccentricity > b.eccentricity) return sortRule[sortType.asc][0];
    if (a.eccentricity < b.eccentricity) return sortRule[sortType.asc][1];
    return 0;
  });

  // 凡例情報から描画色を取得
  const color = getLegendInfo(key)?.color || "#000000";

  // 線種に応じて描画パターンを指定
  let strokeDasharray;
  switch (key) {
    case curveInfo.lr.load.key:
    case curveInfo.fb.load.key:
      // 実線
      strokeDasharray = undefined;
      break;
    default:
      // 破線
      strokeDasharray = "5 5";
      break;
  }

  return (
    <RechartsLine
      data={data}
      dataKey="totalLoad"
      legendType="none"
      stroke={color}
      strokeWidth={2}
      strokeDasharray={strokeDasharray}
      dot={false}
      activeDot={false}
      isAnimationActive={false}
      tooltipType="none"
    />
  );
};

export default Line;
